module.exports = __webpack_public_path__ + "static/media/5f8de7ed5ae7590275f07509_banner_800x600.dd9ad141.png";